import { cn } from "@breakout/ui/utils"
import type { ReactNode } from "react"

interface BadgeProps {
	children: ReactNode
	className?: string
}

export function Badge({ children, className }: BadgeProps) {
	return (
		<span
			className={cn(
				"shrink-0 rounded-full border border-breakout-brand/20 bg-breakout-brand/10 px-2 py-0.5 font-medium text-breakout-brand text-xs",
				className,
			)}
		>
			{children}
		</span>
	)
}
